import {
  FormControl,
  Select,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  useToast,
  Box,
} from '@chakra-ui/react';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { ViewIcon } from '@chakra-ui/icons';
// Custom components
import MultiSelect from 'components/autocomplete/autocomplete';
import {
  Modules,
  MakerCheckerTasks,
  MakerCheckerStatus,
} from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import MakerCheckerApi from 'api/makerchecker';
import { useAuth } from 'auth-context/auth.context';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import PageError from 'components/nopermission/PageError';
import DashboardReportApi from 'api/dashboardreport';

//Remove when API sends Data
export default function CheckTable(props) {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  //Data Fetching
  // const [data, setData] = useState([]);
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(['']);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [listTotal, setListTotal] = useState(2);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTaskType, setSelectedTaskType] = useState([]);
  const [selectedStatusType, setSelectedStatusType] = useState();
  const [filterStartDate, setFilterStartDate] = useState();
  const [filterEndDate, setFilterEndDate] = useState();
  const { getPermissionsForModule } = usePermissions();
  const { user } = useAuth();
  const [makerCheckerPermissions, setMakerCheckerPermissions] = useState(null);
  const [fetchMakerCheckerListError, setFetchMakerCheckerListError] =
    useState(false);

  useEffect(() => {
    if (user?.user_type === 'SHOWROOM') {
      const defaultTasks = MakerCheckerTasks.filter((task) =>
        [
          'SAVING_PLAN_CLOSE_STORE',
          'GOLD_SELL_STORE',
          'CASH_DEPOSIT',
        ].includes(task.value)
      );
      setSelectedTaskType(defaultTasks);
      setSelectedStatusType('PENDING');
    }
  }, [user]);

  const selectedTaskTypeValue = Array.isArray(selectedTaskType)
    ? selectedTaskType?.map((option) => option.value).join(',')
    : selectedTaskType.value;

  // console.log(
  //   'from order to check multiselect',
  //   selectedOrderTypeValue,
  //   selectedStatusTypeValue
  // );

  const FetchMakerCheckersList = async () => {
    try {
      setLoading(true);

      let finalTaskType = selectedTaskTypeValue;
      let finalStatusType = selectedStatusType;

      if (user?.user_type === 'SHOWROOM') {
        const showroomTasks = [
          'SAVING_PLAN_CLOSE_STORE',
          'GOLD_SELL_STORE',
          'CASH_DEPOSIT',
        ];

        if (!selectedTaskTypeValue || selectedTaskTypeValue === '') {
          finalTaskType = showroomTasks.join(',');
        } else {
          finalTaskType = selectedTaskTypeValue
            .split(',')
            .filter((task) => showroomTasks.includes(task))
            .join(',');

          if (finalTaskType === '') {
            finalTaskType = showroomTasks.join(',');
          }
        }

        if (selectedStatusType !== 'PENDING') {
          finalStatusType = 'PENDING';
        }
      }

      let response = await MakerCheckerApi.List({
        currentPage,
        itemsPerPage,
        searchTerm,
        selectedTaskTypeValue: finalTaskType,
        selectedStatusType: finalStatusType,
      });
      response = response.data;
      console.log('Response from MakerCheckerApi =', response);
      setLoading(false);
      if (response.status_code === 200) {
        setFetchMakerCheckerListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setFetchMakerCheckerListError(true);
        setList([]);
        setListTotal(0);
      }
    } catch (err) {
      setFetchMakerCheckerListError(true);
      console.log(err);
      setList([]);
    }
  };

  useEffect(() => {
    DashboardReportApi.Notifications();
  }, []);

  useEffect(() => {
    const makerCheckerPermissions = getPermissionsForModule([
      Modules.MakerCheckers,
    ]);
    setMakerCheckerPermissions(makerCheckerPermissions);
  }, [getPermissionsForModule]);

  useEffect(() => {
    if (makerCheckerPermissions?.read) {
      FetchMakerCheckersList();
    }
  }, [
    selectedTaskTypeValue,
    selectedStatusType,
    searchTerm,
    currentPage,
    makerCheckerPermissions,
  ]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedTaskTypeValue, selectedStatusType]);

  const handleSearch = async (search) => {
    setSearchTerm(search);
    setCurrentPage(1); // Reset currentPage to 1 on each search
  };

  // console.log('List conatis', list);

  if (!makerCheckerPermissions?.read) {
    return <NoPermissionsMessage module={Modules.MakerCheckers} />;
  }

  return fetchMakerCheckerListError ? (
    <PageError />
  ) : (
    <>
      <Flex
        mt='8rem'
        px='25px'
        justify='left'
        mb='20px'
        align='center'>
        <Text
          color={textColor}
          fontSize='22px'
          fontWeight='700'
          lineHeight='100%'></Text>
        <Flex
          direction='column'
          gap={4}
          pt={5}>
          <Flex
            direction={{ base: 'column', '2xl': 'row' }}
            gap={4}>
            <Flex
              direction={{ base: 'column', md: 'row' }}
              gap={4}>
              <Box minW={64}>
                <MultiSelect
                  options={
                    user?.user_type === 'SHOWROOM'
                      ? MakerCheckerTasks.filter((task) =>
                        [
                          'SAVING_PLAN_CLOSE_STORE',
                          'GOLD_SELL_STORE',
                          'CASH_DEPOSIT',
                        ].includes(task.value)
                      )
                      : MakerCheckerTasks
                  }
                  placeholder='Select Tasks'
                  value={selectedTaskType}
                  onChange={setSelectedTaskType}
                  isMulti={true}
                />
              </Box>
              <Box>
                <FormControl
                  display='flex'
                  alignItems='center'>
                  <Select
                    id='task-type'
                    value={user?.user_type === 'SHOWROOM' ? 'PENDING' : selectedStatusType}
                    variant='auth'
                    disabled={user?.user_type === 'SHOWROOM'}
                    onChange={(e) => setSelectedStatusType(e.target.value)}>
                    {MakerCheckerStatus.filter((status) => {
                      if (user?.user_type === 'SHOWROOM') {
                        return status.value === 'PENDING' || status.value === '';
                      }
                      return true;
                    }).map((Status) => (
                      <option
                        key={Status.value}
                        value={Status.value}>
                        {Status.label}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}>
        <Table
          variant='striped'
          color='gray.500'
          mb='24px'>
          <Thead>
            <Tr>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Code
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Task
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Status
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Created By
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Creation Time
                </Flex>
              </Th>

              <Th
                pe='25px'
                borderColor={borderColor}>
                <Flex
                  justifyContent='center'
                  // backgroundColor='red'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Actions
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.code}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {
                          MakerCheckerTasks.find(
                            (option) => option.value === obj?.task
                          )?.label
                        }
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        fontSize='sm'
                        fontWeight='700'
                        color={
                          obj.status === 'COMPLETED'
                            ? 'green'
                            : obj.status === 'FAILED'
                              ? 'red'
                              : { textColor }
                        }>
                        {MakerCheckerStatus.find(
                          (option) => option.value === obj?.status
                        )?.label.toUpperCase()}{
                          (obj.required_checks > 1 && obj.status === 'PENDING') ? ' (' + obj.required_checks + ')' : ''
                        }
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.user_type == 'CUSTOMER'
                          ? `${obj.name} (CUSTOMER)`
                          : `${obj.name}`}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        size='sm'
                        fontWeight='700'
                        color={textColor}>
                        {moment(obj.created_at).format('DD MMM YY, HH:mm')}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex justify='center'>
                      {/* <EditModal
                          Icon={<EditIcon />}
                          head={'Update Customer Admin User'}
                          func={FetchMakerCheckersList}
                          currentUser={obj}
                        /> */}
                      <Chakralink>
                        <Link
                          to={{
                            pathname: `/admin/makerchecker/${obj.id}`,
                          }}>
                          <Button>
                            <ViewIcon />
                          </Button>
                        </Link>
                      </Chakralink>
                      {/* {obj.is_active === true ? (
                        <PopDelete
                          Icon={<DeleteIcon />}
                          button={
                            <Button
                              colorScheme='red'
                              onClick={handleDelete}
                              value={obj.id}>
                              Delete
                            </Button>
                          }
                        />
                      ) : (
                        'Disabled'
                      )} */}
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </>
  );
}
